<template>
  <ComponentsLayoutWithNavbar
    id="bid-history-by-participants"
    main_color="var(--color-main-green)">
    <template #breadcrumbs>
      <TenderBreadcrumbs :additional_breads="breads"/>
    </template>
    <template #main_content>
      <template v-if="loading">
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-10 pr-8"
          :tile="true"
          type="heading"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-3 pr-8"
          :tile="true"
          type="sentences"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-4 main__green mt-5"
          :tile="true"
          type=" table-thead, table-tbody"
          width="100%"/>
      </template>
      <v-card
        v-else
        class="width-100 px-0 main__green pt-3"
        elevation="0">
        <v-card-title class="h1-headline px-0 pt-2">
          {{ participant.organizationName || '–' }}
        </v-card-title>
        <v-card-text class="pl-0 pr-2 pt-8">
          <BidHistoryScatterChart
            v-if="info.length"
            by="lotTitle"
            :items="info"
            :title="$t('Tenders.ReducingPriceOfParticipant')"/>
        </v-card-text>
        <v-card-text class="pl-0 pr-2 pt-2">
          <FilterBar
            :all-headers="view_types"
            :choosed-headers.sync="view"
            class="mb-6"
            named_view
            without_filter
            @applySearch="applySearch"/>
          <OffersGroups
            ref="offers_groups"
            :bid_groups="bid_groups"
            :bids="searched"
            :can_expand="view.value != 'ALL'"
            :critery-card="criteryCard"
            hide_foreign
            mode="history"
            :select="selecting"
            :tender="tender"
            :with_header="view.value != 'ALL'">
            <template #title="{ group }">
              {{ formatDate( group.title) }}
            </template>
          </OffersGroups>
        </v-card-text>
      </v-card>
    </template>
    <template #nav_bar="{ mini }">
      <v-container
        v-show="!mini"
        class="lot-info pa-0 main__light_green flex-direction-column"
        fill-height>
        <template v-if="loading">
          <v-skeleton-loader
            class="mt-10 px-8"
            height="50px"
            type="heading"
            width="80%"/>
          <v-skeleton-loader
            v-for="(i, n) in new Array(3)"
            :key="n"
            class="mt-3 px-8"
            height="50px"
            type="sentences"
            width="100%"/>
        </template>
        <template v-else>
          <v-card class=" ma-0 pb-5 secondary__green_chosen info-list">
            <v-card-title class="h4-headline pt-6 pl-6">
              {{ $t(`StopLists.AboutSupplier`) }}
            </v-card-title>
            <v-card-text class="py-0 px-6">
              <v-list
                class="py-0"
                :color="'var(--v-secondary__green_chosen-base)'">
                <div class="list-item px-0 flex flex-direction-column align-start">
                  <div class="h9-label ">
                    {{ $t('Purchasing.Status') }}
                  </div>
                  <div class="flex flex-direction-column align-start">
                    <StatusChip
                      class=" my-2"
                      key-name="verificationStatusId"
                      :status="status"
                      value-name="title"/>
                    <StatusChip
                      v-if="participant.verificationDecision"
                      class=" mb-2"
                      key-name="decisionTypeId"
                      :status="decision_status"
                      value-name="title"/>
                    <ExternalParticipantChip
                      v-if="participant.foreignBidderBid"
                      class=" mb-2"/>
                  </div>
                </div>
                <v-list-item
                  v-if="participant.verificationStatus == 'VERIFIED'"
                  class="px-0">
                  <v-list-item-content class="py-2">
                    <v-list-item-subtitle class="h9-label px-0 ">
                      {{ $t('Suppliers.Comment') }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ participant.comment || '–' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="ma-0 pa-0">
                  <v-list-item-content class="py-2">
                    <v-list-item-subtitle class="h9-label px-0 ">
                      {{ $t('Tenders.EDRPOU') }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      <span class="text-decoration-underline">
                        {{ participant.usreou ? participant.usreou.trim() : '–' }}
                      </span>
                      <sButton
                        v-if="participant.usreou"
                        class="ml-2"
                        icon="draft"
                        icon-size="20px"
                        small
                        type="text"
                        @click="$_copyUsreou(participant)"/>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="ma-0 pa-0">
                  <v-list-item-content class="py-2">
                    <v-list-item-subtitle class="h9-label px-0 py-0">
                      {{ bigFirstLetter($t(`Tenders.ContactPerson`)) }}
                    </v-list-item-subtitle>
                    <v-list-item-title class="h7-text text-start px-0 pb-0 black--text">
                      {{ participant.fullName || '–' }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="h8-text secondary__green_not_active--text text-start px-0">
                      <div> {{ participant.email || '–' }}</div>
                      <div> {{ participant.phoneNumber || '–' }}</div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
          <router-link
            class="d-flex align-self-center mt-auto mb-3"
            :to="{name: 'bidsHistory', params: { tenderId: tender.tenderId, org: $route.params.org}}">
            <sButton
              class="h7-text"
              type="text"
              @click="$emit('update:dialog', false)">
              <sIcon
                class="s-btn-icon"
                rotate="90"
                size="10"
                type="long-arrow"/>
              {{ $t('Tenders.BackToHistory') }}
            </sButton>
          </router-link>
        </template>
      </v-container>
    </template>
  </ComponentsLayoutWithNavbar>
</template>
<script>
import FilterBar from 'components/common/blocks/FilterBar.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import OffersGroups from 'components/tenders/tender page/OffersGroups.vue'
import ComponentsLayoutWithNavbar from 'pages/templates/ComponentsLayoutWithNavbar.vue'
import ExternalParticipantChip from 'components/tenders/tender page/ExternalParticipantChip.vue'
import BidHistoryScatterChart from 'components/tenders/tender page/bids history/BidHistoryScatterChart.vue'

import moment from 'moment'
import { measureMixin, modalMixin, snackbarMixin, supplierMixin, tenderMixin, bidHistoryHeadersMixin } from 'mixins'

export default {
  name: 'bidHistoryByParticipants',
  mixins: [ measureMixin, modalMixin, tenderMixin, snackbarMixin, supplierMixin, bidHistoryHeadersMixin ],
  data() {
    return {
      bids: [],
      info: [],
      tender: {},
      participant: {},
      loading: false,
      selected: [],
      view: {},
      searched: [],
      currencies: [],
      criteryCard: null
    }
  },
  filters: {
    formatDateMonth(val) {
      return moment(val).format('DD MMMM')
    },
    formatTime(val) {
      return moment(val).format('HH:mm')
    },
  },
  async created() {
    this.$store.dispatch('getCrmVerificationFillingInfo')
    this.view = this.view_types[0]
    this.setTenderMeasurements()
    await this.getItem()
  },
  computed: {
    breads() {
      return [
        {
          text: this.$t('Tenders.History'),
          to: {name: 'bidsHistory', params: { tenderId: this.tender.tenderId, org: this.$route.params.org}}
        },
        {
          text: this.$t('Tenders.Suppliers'),
          current: true
        },
        {
          text: this.participant?.organizationName
        }
      ]
    },
    view_types() {
      return [
        { text: this.$t('Purchasing.All'), value: 'ALL'},
        { text: this.$t('Tenders.ByLots'), value: 'LOTS' },
        { text: this.$t('Tenders.ByPropositions'), value: 'BIDS' },
      ]
    },
    bid_groups() {
      let filter = this.view.value == 'LOTS' ? 'lotTitle' : this.view.value == 'BIDS' ? 'timeSupplyBids' : ''
      return this.$_.map( this.getGroups(this.searched, filter), el => ({...el, formatHeaders: this.formatHeaders}))
    },
    snackar_options() {
      return {
        name: 'lot-offers-history',
        compare_name: 'participantHistoryComparativeTable',
        participant: +this.$route.params.participantId,
        tender: this.tender,
      }
    }
  },
  methods: {
    async getItem(condition) {
      this.loading = true
      const promises = [
        await this.$store.dispatch('getTenderItem', {id: +this.$route.params.tenderId, condition: condition})
          .then(res => {
            this.tender = res
          }),

        await this.$store.dispatch('getTenderBidHistory', {tenderId: +this.$route.params.tenderId, model: {bidderId: +this.$route.params.participantId}})
          .then( async res => {
            if ( !res ) {
              this.$notice.closeAll()
              this.$notice.info({
                title: this.$t('Common.ErrorTitle'),
                message: this.$t('Errors.STHWrong'),
                showClose: true,
                progress: true,
                duration: 10
              })
              return this.$router.push({name: 'bidsHistory', params: { tenderId: this.tender.tenderId, org: this.$route.params.org}})
            }

            await this.$store.dispatch('setCurrencies')
              .then(res => this.currencies = res)
            this.participant = {...res[0]?.bidderInfo, foreignBidderBid: res[0]?.foreignBidderBid}
            this.bids = this.getBids(res, this.tender)
            this.info = this.bids.map(bid => ({...bid,
              x: bid.timeSupplyBids,
              y: bid.currencyPrice }))
            this.searched = this.bids.slice(0)
          })
      ]

      await Promise.all(promises)
      await this.$store.dispatch('infoAboutCriterionCard', {save: true, id: this.tender.criteriaCard}).then(res => this.criteryCard = res)
      this.loading = false
    },
    formatHeaders(headers) {
      headers = headers.filter(el => el.value != 'name' && el.value != 'status')
      headers.splice(2, 0, ...this.$_bidHistoryDateHeaders)
      headers.splice(-1, 1,
        {text: '', value: 'isCanceled', width: '7%', sortable: false },
      )

      if ( this.view.value == 'LOTS') {
        headers.splice(1, 1)
      } else if ( this.view.value == 'BIDS' ) {
        headers.splice(2, 1)
      }
      return headers
    },
    applySearch(search) {
      this.searched = this.bids.filter(bid => bid.lotTitle.toLocaleLowerCase().includes(search.toLocaleLowerCase()) )
    },
    formatDate(value) {
      if ( this.view.value != 'LOTS' && value) {
        return moment(value).format('DD MMMM, HH:mm')
      } else {
        return value || '–'
      }
    },
    selecting(selected, group) {
      let selected_items = []
      group.selected = selected
      this.bid_groups.forEach(group => {
        selected_items.push(...group.selected)
      })
      if (selected_items.length ) {
        this.$_openSnackbar({
          ...this.snackar_options,
          elements: selected_items,
          callback: () => {
            this.bid_groups.forEach(group => group.selected = [])
            this.$refs.offers_table.forEach(item => item.selected = [])
            this.$_closeSnackbar()
          }
        })
      } else if (selected_items.length == 0) {
        this.$_closeSnackbar()
      }
    },
  },
  components: {
    FilterBar,
    StatusChip,
    OffersGroups,
    TenderBreadcrumbs,
    BidHistoryScatterChart,
    ExternalParticipantChip,
    ComponentsLayoutWithNavbar
  }
}
</script>
